class About {
    namespace: HTMLElement | null;
    
    constructor() {
        this.namespace = document.getElementById('page-about');    
        this.initPage();
    }

    initPage() {
        if (!this.namespace) return;
    } 
}
export default About;